import React from 'react';

interface IconWebsiteProps {
  className?: string;
  size?: number | string;
}

const IconWebsite = (props: IconWebsiteProps) => {
  const size = props.size ?? '24';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={props.className}
    >
      <g fill="currentColor">
        <path
          fillRule="evenodd"
          d="M14 7a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zm3 2h-2v6h2z"
          clipRule="evenodd"
        />
        <path d="M6 7a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2zm-1 5a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1" />
        <path
          fillRule="evenodd"
          d="M4 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm16 2H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1"
          clipRule="evenodd"
        />
      </g>
    </svg>
  );
};

export default IconWebsite;
